module.exports = __webpack_public_path__ + "static/media/arrow-right-black.aad3ccbb.svg";